<template>
  <div class="content_all2" id="site_inq">
    <div class="content_box" v-show="!shopcar && !sentcheck">
      <Modal v-model="modal_rent" class-name="vertical-center-modal">
        <p slot="header">
          <span>{{rentRecord.buildingName}}</span>
          <span>{{rentRecord.venueName}}</span>
        </p>
        <div>
          <table width="100%">
            <tr>
              <td>活動名稱</td>
              <td>{{rentRecord.activityName}}</td>
            </tr>
            <tr>
              <td>活動日期</td>
              <td>{{rentRecord.beginDate && rentRecord.beginDate.split(' ')[0]}} 起至 {{rentRecord.endDate && rentRecord.endDate.split(' ')[0]}}</td>
            </tr>
            <tr>
              <td>活動時間</td>
              <td>{{rentRecord.timePeriod && rentRecord.timePeriod.toString()}}</td>
            </tr>
            <tr>
              <td>活動地點</td>
              <td>{{rentRecord.buildingVenueName}}</td>
            </tr>
            <tr>
              <td>活動內容</td>
              <td></td>
            </tr>
            <tr>
              <td>主辦單位</td>
              <td>{{rentRecord.unitName}} </td>
            </tr>
            <tr>
              <td>備註</td>
              <td></td>
            </tr>
          </table>
        </div>
        <div slot="footer">
        </div>
      </Modal>
      <Modal v-model="modal_reserve" class-name="vertical-center-modal">
        <p slot="header">
          <span>{{reserveRecord.buildingName}}</span>
          <span>{{reserveRecord.venueName}}</span>
        </p>
        <div>
          <table width="100%">
            <tr>
              <td>預約日期</td>
              <td>{{reserveRecord.rentDate && reserveRecord.rentDate.split(' ')[0]}}</td>
            </tr>
            <tr>
              <td>預約時間</td>
              <td>{{reserveRecord.rentTimePeriod}}</td>
            </tr>
            <tr>
              <td>預約人</td>
              <td>{{reserveRecord.isYearUser ? reserveRecord.yearUserUnitName:reserveRecord.unitName}}</td>
            </tr>
            <tr>
              <td>申請日期</td>
              <td>{{reserveRecord.createdAt}}</td>
            </tr>
            <tr>
              <td>預約狀態</td>
              <td>已預約</td>
            </tr>
            <tr>
              <td>備註</td>
              <td></td>
            </tr>
          </table>
        </div>
        <div slot="footer">
        </div>
      </Modal>
      <Modal v-model="modal_wantreser" class-name="vertical-center-modal">
        <p slot="header">
        </p>
        <div>
          <table width="100%">
            <tr>
              <td>建物名稱</td>
              <td>{{requestReserve.buildingName}}</td>
            </tr>
            <tr>
              <td>場地名稱</td>
              <td>{{requestReserve.venueName}}</td>
            </tr>
            <tr>
              <td>預約時段</td>
              <td>{{requestReserve.date}} {{requestReserve.timePeriod}}</td>
            </tr>
          </table>
          <p style="text-align:center;font-size: 18px;margin: 20px;">確定預約此場地時段？</p>
        </div>
        <div slot="footer" style="text-align: center;">
          <Button type="primary" @click="saveData">是，送出預約</Button>
          <Button @click="modal_wantreser = false">否，回上一步</Button>
        </div>
      </Modal>
      <Modal v-model="modal_wantreser_notlog" class-name="vertical-center-modal">
        <p slot="header">
        </p>
        <div>
          <p style="text-align:center;font-size: 18px;margin: 20px;">請先登入</p>
        </div>
        <div slot="footer" style="text-align: center;">
          <Button type="primary" @click="toLogIn">是，回到登入頁</Button>
          <Button @click="modal_wantreser_notlog = false">否，回上一步</Button>
        </div>
      </Modal>
      <div class="site_inqbox">
        <table style="width: 100%">
          <tr>
            <td>場館名稱</td>
            <td style="width: 309px;">
              <Select style="width:150px;" v-model="buildingId">
                <Option v-for="(building,index) in buildings" :key="index" :value="building.id">{{building.buildingName}}</Option>
              </Select>
              <Select style="width:150px;" v-model="venueId">
                <Option v-if="venue.buildingId === buildingId " v-for="(venue,index) in venues" :key="index" :value="venue.id">{{venue.venueName}}</Option>
              </Select>
            </td>
            <td>查詢日期</td>
            <td style="width: 200px;">
              <DatePicker type="date" placeholder="Select date" :value="searchDate" @on-change="searchDateChange" @on-clear="searchDateClear"></DatePicker>
            </td>
            <td>
              <button type="submit" class="btn_m" @click="search">查詢</button>
            </td>
            <td>
              <a href="../static/rent_application.doc" download>
                <button type="submit" class="btn_n">列印書面租借申請書</button>
              </a>
            </td>
            <td>
              <button type="submit" class="star_btn" @click="shopcar = true">
                <i class="fa fa-star" aria-hidden="true"></i>
                <div class="tx14">抽籤登記({{tempRents.length}})</div>
              </button>
            </td>
          </tr>
        </table>
      </div>
      <table width="100%" class="mb10" v-if="this.venueId">
        <tr>
          <td width="50%">
            <button type="submit" class="btn_n" @click="preweek">上一周</button>
          </td>
          <td width="50%" align="right">
            <button type="submit" class="btn_n" @click="nextweek">下一周</button>
          </td>
        </tr>
      </table>
      <div class="list_box3" v-if="this.venueId" style="position: relative;">
        <table>
          <tr>
            <th>日期 \ 時段</th>
            <th v-for="(date,index) in tableShowDate" :key="index">{{showDate(date)}}{{showDay(index)}}</th>
          </tr>
          <tr v-for="(period,indexTime) in periods" :key="indexTime">
            <td bgcolor="#F9FAFA">{{period.timePeriod}}</td>
            <td v-for="(date,indexDate) in tableShowDate" :key="indexDate">
              <i style="cursor:pointer" class="fa fa-check-circle-o mr5" aria-hidden="true" v-if="findActivity(period.timePeriod,date,indexTime,indexDate)" @click="showRentModal(tableObj[indexTime][indexDate])">
                {{showName(indexTime,indexDate)}}
              </i>
              <i style="cursor:pointer" class="fa fa-dribbble mr5" aria-hidden="true" v-else-if="findRent(period.timePeriod,date,indexTime,indexDate)" @click="showReserveModal(tableObj[indexTime][indexDate])">{{tableObj[indexTime][indexDate].yearUserUnitName}}{{tableObj[indexTime][indexDate].unitName}}</i>
              <i style="cursor:pointer" class="fa fa-user-plus" aria-hidden="true" v-else-if="duringMonth(date)" @click="showRequestModal(period.timePeriod,date)"></i>
              <i style="cursor:pointer" class="fa fa-user-plus" aria-hidden="true" v-else-if="notLogIn(date)" @click="showRequestModal(period.timePeriod,date)"></i>
              <i style="cursor:pointer" class="fa fa-user-plus" aria-hidden="true" v-else-if="nextMonthAfterLottery(date)" @click="showRequestModal(period.timePeriod,date)"></i>
              <i style="cursor:pointer" class="fa fa-star" aria-hidden="true" v-else-if="findRentSelf(period.timePeriod,date,indexTime,indexDate) && rentLimit(venueId)" @click="cancelTempRents(period.timePeriod, date, venueId)"></i>
              <i style="cursor:pointer" class="fa fa-star-o" aria-hidden="true" v-else-if="duringLottery(date) && rentLimit(venueId)" @click="addTempRents(period.timePeriod, date, venueId)"></i>
            </td>
          </tr>
        </table>
        <Spin size="large" fix v-if="spinShow"></Spin>
      </div>
      <div v-show="spinShow">
        <div class="mt5">臺大體育館及戶外場地線上訂位系統借用流程</div>
        <div class="mt5">1. 每個月15日00：00系統開放登記抽籤。</div>
        <div class="mt5">2. 登入並選擇時段與場地登記抽籤，完成登記。 </div>
        <div class="mt5">3. 系統會發信通知確認，公佈已登記者。 </div>
        <div class="mt5">4. 20日08：00停止抽籤登記。 </div>
        <div class="mt5">5. 20日08：01以系統亂數抽籤決定中選者</div>
        <div class="mt5">6. 系統亂數抽籤後即公佈抽籤結果，發信通知抽籤結果。 </div>
        <div class="mt5">7. 若中籤，請於7日內至舊體育館辦理登記手續。</div>
        <div class="mt5">8. 若未中籤，08：30後預約其他場地與時段。 </div>
        <div class="mt5">9. 場地在未登記前可於2日前隨時辦理登記時段。 </div>
        <div class="mt5">10. 未於每個預定場地3日前取消預約場地，仍列入已使用一點數。 </div>
        <div class="mt5">11. 已登記使用但未到場，累計3次將處以停權，以保障其他使用人權利。</div>
      </div>
      <div class="mt5">若有任何線上預約的問題，請洽電(02)33669515，或至體育館辦公室詢問。</div>
      <div v-show="!spinShow">
        <div class="mt5">圖示說明：
          <i class="fa fa-check-circle-o mr5" aria-hidden="true"></i>已出借/已繳費
          <i class="fa fa-dribbble mr5" aria-hidden="true"></i>已預約
          <i class="fa fa-user-plus mr5 ml10" aria-hidden="true"></i>預約
          <i class="fa fa-star-o mr5 ml10" aria-hidden="true"></i>可登記抽籤
          <i class="fa fa-star mr5 ml10" aria-hidden="true"></i>已登記抽籤</div>
      </div>
    </div>
    <div class="content_box" v-show="shopcar">
      <div class="list_box3">
        <div class="y_ititle2">場地登記</div>
        <table>
          <tr>
            <th>場地</th>
            <th>登記日期</th>
            <th>登記時段</th>
            <th>狀態</th>
            <th>操作</th>
          </tr>
          <tr v-for="(rent,index) in tempRents" :key="index">
            <td>
              {{rent.buildingName}}-{{rent.venueName}}
            </td>
            <td>
              {{rent.date && rent.date.split(' ')[0]}}
            </td>
            <td>
              {{rent.timePeriod}}
            </td>
            <td>
              未送出登記
            </td>
            <td width="80">
              <button type="submit" class="srbtn" @click="cancelTempRentsIndex(index)"><i class="fa fa-times" aria-hidden="true"></i></button>
            </td>
          </tr>
        </table>
      </div>
      <p style="text-align:center;margin-top: 40px;">
        <button class="btn_m" @click="sentcheckout">確認送出</button>
        <button class="btn_n" @click="shopcar = false">回場地查詢</button>
      </p>
    </div>
    <div class="content_box" v-show="sentcheck">
      <div class="list_box3">
        <div class="y_ititle2">場地登記</div>
        <table>
          <tr>
            <th>登記編號</th>
            <th>場地</th>
            <th>登記日期</th>
            <th>登記時段</th>
            <th>申請日期</th>
            <th>狀態</th>
            <th>操作</th>
          </tr>
          <tr v-for="(rent,index) in tempRentsRes" :key="index">
            <td bgcolor="#F9FAFA">
              {{rent.id}}
            </td>
            <td>
              {{rent.buildingName}}-{{rent.venueName}}
            </td>
            <td>
              {{rent.rentDate && rent.rentDate.split(' ')[0]}}
            </td>
            <td>
              {{rent.rentTimePeriod}}
            </td>
            <td>
              {{rent.createdAt && rent.createdAt.split(' ')[0]}}
            </td>
            <td>
              <span v-if="rent.id==undefined">登記失敗</span>
              <span v-else>等候抽籤</span>
            </td>
            <td width="80">
              <!--<button type="submit" class="srbtn" @click="cancel(rent)"><i class="fa fa-times" aria-hidden="true"></i></button>-->
            </td>
          </tr>
        </table>
      </div>
      <p style="text-align:center;margin-top: 40px;">
        <button type="submit" class="btn_n" @click="shopcar = false; sentcheck = false; tempRentsRes = []">回場地查詢</button>
      </p>
    </div>
    <div style="width: 1000px;margin:auto;" v-if="!venueId"><img style="width: 1000px; height: auto" src="/../../static/map1.png" usemap="#image-map"></div>
    <map name="image-map">
      <area target="" alt="綜合球場" title="綜合球場" coords="655,439,769,561" shape="rect" @click="buildingId=13;venueId = 67">
      <area target="" alt="桌球室" title="桌球室" coords="774,439,828,476" shape="rect" @click="buildingId=13;venueId = 69">
      <area target="" alt="舞蹈教室" title="舞蹈教室" coords="604,440,649,507" shape="rect" @click="buildingId=13;venueId = 70">
      <area target="" alt="柔道場" title="柔道場" coords="605,512,649,563" shape="rect" @click="buildingId=13;venueId = 71">
      <area target="" alt="籃球場甲" title="籃球場甲" coords="598,384,654,427" shape="rect" @click="buildingId=13;venueId = 78">
      <area target="" alt="籃球場乙" title="籃球場乙" coords="657,384,714,428" shape="rect" @click="buildingId=13;venueId = 79">
      <area target="" alt="籃球場丙" title="籃球場丙" coords="718,384,773,427" shape="rect" @click="buildingId=13;venueId = 80">
      <area target="" alt="籃球場丁" title="籃球場丁" coords="778,384,834,428" shape="rect" @click="buildingId=13;venueId = 81">
      <area target="" alt="籃球場戊" title="籃球場戊" coords="838,385,894,428" shape="rect" @click="buildingId=13;venueId = 82">
      <area target="" alt="籃球場己" title="籃球場己" coords="625,576,682,619" shape="rect" @click="buildingId=13;venueId = 119">
      <area target="" alt="籃球場庚" title="籃球場庚" coords="685,577,742,620" shape="rect" @click="buildingId=13;venueId = 120">
      <area target="" alt="籃球場辛" title="籃球場辛" coords="744,576,801,621" shape="rect" @click="buildingId=13;venueId = 121">
      <area target="" alt="籃球場壬" title="籃球場壬" coords="807,576,862,620" shape="rect" @click="buildingId=13;venueId = 122">
      <area target="" alt="排球場1" title="排球場1" coords="626,631,662,702" shape="rect" @click="buildingId=13;venueId = 83">
      <area target="" alt="排球場2" title="排球場2" coords="666,632,701,701" shape="rect" @click="buildingId=13;venueId = 84">
      <area target="" alt="排球場3" title="排球場3" coords="706,631,741,701" shape="rect" @click="buildingId=13;venueId = 85">
      <area target="" alt="排球場4" title="排球場4" coords="745,632,780,702" shape="rect" @click="buildingId=13;venueId = 86">
      <area target="" alt="排球場5" title="排球場5" coords="786,632,821,702" shape="rect" @click="buildingId=13;venueId = 87">
      <area target="" alt="排球場6" title="排球場6" coords="826,632,860,702" shape="rect" @click="buildingId=13;venueId = 88">
      <area target="" alt="排球場7" title="排球場7" coords="864,631,899,701" shape="rect" @click="buildingId=13;venueId = 89">
      <area target="" alt="草地手球場" title="草地手球場" coords="453,477,523,556" shape="rect" @click="buildingId=13;venueId = 184">
      <area target="" alt="田徑場" title="田徑場" coords="261,394,254,446,252,511,254,575,266,632,305,660,350,668,394,661,422,641,439,601,440,537,443,486,442,432,424,374,383,349,338,345,306,351,282,368,285,436,412,435,414,579,282,580,283,436,285,436,283,370" shape="poly" @click="buildingId=13;venueId = 95">
      <area target="" alt="足球場" title="足球場" coords="284,435,412,577" shape="rect" @click="buildingId=13;venueId = 96">
      <area target="" alt="中央籃球場1" title="中央籃球場1" coords="648,298,684,370" shape="rect" @click="buildingId=13;venueId = 105">
      <area target="" alt="中央籃球場2" title="中央籃球場2" coords="687,298,725,369" shape="rect" @click="buildingId=13;venueId = 104">
      <area target="" alt="中央籃球場3" title="中央籃球場3" coords="728,299,765,368" shape="rect" @click="buildingId=13;venueId = 103">
      <area target="" alt="新生籃球場1" title="新生籃球場1" coords="181,631,219,693" shape="rect" @click="buildingId=13;venueId = 116">
      <area target="" alt="新生籃球場2" title="新生籃球場2" coords="223,633,257,692" shape="rect" @click="buildingId=13;venueId = 117">
      <area target="" alt="新生籃球場3" title="新生籃球場3" coords="584,632,621,702" shape="rect" @click="buildingId=13;venueId = 118">
      <area target="" alt="人工草皮球場" title="人工草皮球場" coords="452,374,524,469" shape="rect" @click="buildingId=13;venueId = 196">
      <area target="" alt="棒壘球場練習區" title="棒壘球場練習區" coords="258,196,308,354" shape="rect" @click="buildingId=13;venueId = 197">
      <area target="" alt="棒球場" title="棒球場" coords="425,261,529,367" shape="rect" @click="buildingId=13;venueId = 90">
      <area target="" alt="壘球場" title="壘球場" coords="310,197,410,287" shape="rect" @click="buildingId=13;venueId = 91">
      <area target="" alt="籃球場A" title="籃球場A" coords="734,964,801,1006" shape="rect" @click="buildingId=14;venueId = 109">
      <area target="" alt="籃球場B" title="籃球場B" coords="733,1013,802,1055" shape="rect" @click="buildingId=14;venueId = 110">
      <area target="" alt="游泳池" title="游泳池" coords="690,223,793,282" shape="rect" @click="buildingId=13;venueId = 107">
      <area target="" alt="紅土網球場" title="紅土網球場" coords="453,562,523,665" shape="rect" @click="buildingId=13;venueId = 101">
      <area target="" alt="網球場1" title="網球場1" coords="181,695,217,767" shape="rect" @click="buildingId=13;venueId = 97">
      <area target="" alt="網球場2" title="網球場2" coords="222,695,256,766" shape="rect" @click="buildingId=13;venueId = 98">
      <area target="" alt="網球場3" title="網球場3" coords="291,696,325,766" shape="rect" @click="buildingId=13;venueId = 99">
      <area target="" alt="網球場4" title="網球場4" coords="328,695,364,766" shape="rect" @click="buildingId=13;venueId = 100">
      <area target="" alt="網球場5" title="網球場5" coords="370,696,405,766" shape="rect" @click="buildingId=13;venueId = 192">
      <area target="" alt="網球場6" title="網球場6" coords="410,696,445,767" shape="rect" @click="buildingId=13;venueId = 193">
      <area target="" alt="網球場7" title="網球場7" coords="449,697,484,767" shape="rect" @click="buildingId=13;venueId = 194">
      <area target="" alt="網球場8" title="網球場8" coords="489,697,523,767" shape="rect" @click="buildingId=13;venueId = 195">
      <area target="" alt="高爾夫球練習場" title="高爾夫球練習場" coords="773,300,840,371" shape="rect" @click="buildingId=13;venueId = 200">
      <area target="" alt="體育館後舞台" title="體育館後舞台" coords="838,442,893,566" shape="rent" @click="buildingId=13;venueId = 201">
    </map>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, PostErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';
var flagcount
export default {
  name: 'site_inq',
  data() {
    return {
      spinShow: true,
      flag: false,
      yearUserId: sessionStorage.YearUserId,
      yearuser: '',
      periods: [],
      activities: [],
      rents: [],
      buildings: [],
      venues: [],
      buildingId: '',
      venueId: '',
      schedule: '',
      countLimit: '',
      tableSDate: '',
      tableEDate: '',
      tableShowDate: [],
      weekDate: '',
      nextMonthSDate: '',
      nextMonthEDate: '',
      searchDate: '',
      modal_rent: false,
      modal_reserve: false,
      modal_wantreser: false,
      modal_wantreser_notlog: false,
      shopcar: false,
      sentcheck: false,
      tempRents: [
        // {timePeriod,rentDate,venueId}
      ],
      tempRentsRes: [],
      rentRecord: {
        buildingName: '',
        venueName: '',
        activityName: '',
        timePeriod: [],
        buildingVenueName: '',
        unitName: '',
      },
      reserveRecord: {
        buildingName: '',
        VenueName: '',
        date: '',
        timePeriod: '',
        name: '',
        requestDate: '',
      },
      requestReserve: {
        date: '',
        timePeriod: '',
      },
      userRegisterRentCount: '',
      tableObj: {},
      recordExistRents: {},
      recordExistActivities: {},
    };
  },
  watch: {
    venueId() {
      this.spinShow = false
    }
  },
  created() {
    axios.defaults.headers.common['X-Jesda-Api-Key'] = sessionStorage.getItem("TokenID");
    this.init();
  },
  methods: {
    // initVenueid() {
    //   this.venueId = ''
    // },
    init() {
      this.initNextMonthDate();
      this.initWeekDate();
      this.initTableDate();
      this.getYearUser();
      this.getSchedule();
      this.getPeriodOption();
      this.getActivity();
      this.getRent();
      this.getBuildingsData();
      this.getVenuesData();
      this.getUserRegisterRentCount();
    },
    initNextMonthDate() {
      let now = new Date(),
        year = now.getFullYear(),
        month = now.getMonth() + 2;
      if (month > 12) {
        month = 1;
        year += 1;
      }
      let dateEnd = new Date(year, month, 0).getDate();
      this.nextMonthSDate = `${year}-${month}-01`;
      this.nextMonthEDate = `${year}-${month}-${dateEnd}`;
    },
    initWeekDate() {
      let now = this.searchDate ? new Date(this.searchDate) : new Date();
      let eDate = now.getDate() + 7,
        currentMonthFinalDay = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate(),
        eMonth = now.getMonth() + 1,
        eYear = now.getFullYear();

      if (eDate > currentMonthFinalDay) {
        eDate -= currentMonthFinalDay;
        eMonth += 1;
        if (eMonth > 12) {
          eMonth = 1;
          eYear += 1;
        }
      }
      this.weekDate = `${eYear}-${eMonth}-${eDate}`;
    },
    initTableDate() {
      let now = this.searchDate ? new Date(this.searchDate) : new Date();
      let nowDay = now.getDay() === 0 ? 7 : now.getDay(),
        sDate = now.getDate() - nowDay + 1,
        eDate = now.getDate() - nowDay + 7,
        currentMonthFinalDay = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate(),
        lastMonthFinalDay = new Date(now.getFullYear(), now.getMonth(), 0).getDate(),
        sMonth = now.getMonth() + 1,
        eMonth = now.getMonth() + 1,
        sYear = now.getFullYear(),
        eYear = now.getFullYear();
      if (sDate < 1) {
        sDate = lastMonthFinalDay + sDate;
        sMonth -= 1;
        if (sMonth < 1) {
          sMonth = 12;
          sYear -= 1;
        }
      }
      if (eDate > currentMonthFinalDay) {
        eDate -= currentMonthFinalDay;
        eMonth += 1;
        if (eMonth > 12) {
          eMonth = 1;
          eYear += 1;
        }
      }

      this.tableSDate = `${sYear}-${getdate(sMonth)}-${getdate(sDate)}`;
      this.tableEDate = `${eYear}-${getdate(eMonth)}-${getdate(eDate)}`;

      let nextDateTime = new Date(this.tableSDate).getTime(),
        dateArr = this.tableEDate.split('-'),
        tableEDateTime = new Date(dateArr[0], parseInt(dateArr[1]) - 1, dateArr[2], 23, 59, 59).getTime();

      this.tableShowDate = [];
      while (nextDateTime <= tableEDateTime) {
        let nextDate = new Date(nextDateTime),
          day = getdate(nextDate.getDate());
        var mm = nextDate.getMonth() + 1
        if (mm < 10) {
          mm = '0' + mm
        }
        this.tableShowDate.push(`${nextDate.getFullYear()}-${mm}-${day}`);
        nextDateTime += 24 * 60 * 60 * 1000;
      }

      function getdate(val) {
        return val < 10 ? '0' + val : val;
      }
    },
    getPeriodOption() {
      axios.get(API.rent_periodoption)
        .then(response => {
          this.periods = response.data.filter(data => {
            return data.trash !== 1;
          });
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getYearUser() {
      if (this.yearUserId) {
        axios.get(API.rent_yearuser + `?id=${this.yearUserId}`)
          .then(response => {
            this.yearuser = response.data;
            this.getCountLimit();
          })
          .catch(error => {
            GetErrorHandler.bind(this)(error);
          });
      }

    },
    getActivity() {
      this.flag = false
      flagcount = 0
      let thisSDate = this.tableSDate;
      if (this.recordExistActivities[this.tableSDate]) {
        this.activities = this.recordExistActivities[this.tableSDate]
        return;
      }
      axios.get(API.rent_activityused + `?sdate=${this.tableSDate}&edate=${this.tableEDate}`)
        .then(response => {
          this.activities = response.data.filter(data => {
            return data.trash !== 1;
          });
          this.recordExistActivities[thisSDate] = JSON.parse(JSON.stringify(this.activities));
        })
        .then(() => {
          this.flag = true

        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getRent(modal) {
      let thisSDate = this.tableSDate;

      if (this.recordExistRents[this.tableSDate]) {
        this.rents = this.recordExistRents[this.tableSDate];
        this.spinShow = false
        return;
      }
      axios.get(API.rent_yearuserrent + `?rentDateS=${this.tableSDate}&rentDateE=${this.tableEDate}`)
        .then(response => {
          this.rents = response.data.filter(data => {
            return data.trash !== 1;
          });
          this.recordExistRents[thisSDate] = JSON.parse(JSON.stringify(this.rents));
          if (modal == 'modal') {
            this.modal_wantreser = false;
          }
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getUserRegisterRentCount() {
      if (this.yearUserId) {
        axios.get(API.rent_yearuserrent + `?yearUserId=${this.yearUserId || ''}&rentDateS=${this.nextMonthSDate}&rentDateE=${this.nextMonthEDate}`)
          .then(response => {
            response.data = response.data.filter(data => {
              return data.trash !== 1;
            });
            this.userRegisterRentCount = response.data.length;
          })
          .catch(error => {
            GetErrorHandler.bind(this)(error);
          });
      }
    },
    getBuildingsData() {
      axios.get(API.rent_building)
        .then(response => {
          this.buildings = response.data.filter(data => {
            return data.trash !== 1;
          });
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getVenuesData() {
      axios.get(API.rent_venue)
        .then(response => {
          this.venues = response.data.filter(data => {
            return data.trash !== 1;
          });
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getSchedule() {
      axios.get(API.rent_schedulesetting + `?id=1`)
        .then(response => {
          this.schedule = response.data;
          this.getCountLimit();
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getCountLimit() {
      if (!this.yearuser || !this.schedule) return;
      let show = ['', this.schedule.undergraduateRegisterLimit, this.schedule.graduateRegisterLimit, this.schedule.groupRegisterLimit];
      this.countLimit = show[this.yearuser.unitType];
    },
    checkTimePeriod(rentTimePeriod, timePeriod) {
      let rts = rentTimePeriod.split('~')[0],
        rte = rentTimePeriod.split('~')[1],
        ts = timePeriod.split('~')[0],
        te = timePeriod.split('~')[1];

      let rtsh = rts.replace('/:/', '').substr(0, 3),
        rteh = rte.replace('/:/', '').substr(0, 3),
        tsh = ts.replace('/:/', '').substr(0, 3),
        teh = te.replace('/:/', '').substr(0, 3);

      return (rtsh <= tsh && teh <= rteh) || (rteh <= teh && teh <= rteh);
    },
    findActivity(timePeriod, date, indexTime, indexDate) {

      let activity = this.activities.filter(activity => {
        let dateTime = new Date(date).getTime(),
          beginDate = new Date(activity.beginDate.split(' ')[0]).getTime(),
          dateArr = activity.endDate.split(' ')[0].split('-'),
          endDate = new Date(dateArr[0], parseInt(dateArr[1]) - 1, dateArr[2], 23, 59, 59).getTime();

        let w = indexDate + 1;
        let week = activity.activityWeek.indexOf(w === 7 ? 0 : w);

        if (beginDate <= dateTime && dateTime <= endDate && week > -1)
          return activity.venueId === this.venueId && activity.timePeriod.includes(timePeriod);
        return false;
      });

      let rent = this.rents.filter(rent => {
        let rentDate = rent.rentDate.split(' ')[0];
        if (rentDate === date) {
          let rentStatus = 0;

          rentStatus =
            rent.venueId === this.venueId &&
            this.checkTimePeriod(rent.rentTimePeriod, timePeriod) &&
            (rent.statusRent === 0 ||
              (rent.statusRent === 1 && rent.statusConfirm === 1) ||
              (rent.statusRent === 2 && rent.statusConfirm === 1 && rent.statusDraw === 1)
            )

          return rentStatus
        }

        return false;
      });
      if (this.flag == true) {
        flagcount += 1
      }
      var amount = this.tableShowDate.length * this.periods.length * 2
      if (flagcount == amount) {
        this.spinShow = false
      }
      let obj = {};
      if (activity[0])
        obj.activity = activity[0];
      else if (rent[0])
        obj.rent = rent[0];
      if (Object.keys(obj).length === 0)
        return false;

      if (!this.tableObj[indexTime])
        this.tableObj[indexTime] = {};
      this.tableObj[indexTime][indexDate] = obj;
      return true;
    },
    findRent(timePeriod, date, indexTime, indexDate) {
      let rent = this.rents.filter(rent => {
        let rentDate = rent.rentDate.split(' ')[0];

        if (rentDate === date) {
          let rentStatus = 0;

          rentStatus =
            rent.venueId === this.venueId &&
            this.checkTimePeriod(rent.rentTimePeriod, timePeriod) &&
            (rent.statusRent === 1 ||
              (rent.statusRent === 2 && rent.statusDraw === 1)
            )

          return rentStatus;
        }

        return false;
      });
      if (rent[0]) {
        if (!this.tableObj[indexTime])
          this.tableObj[indexTime] = {};
        this.tableObj[indexTime][indexDate] = rent[0];
      }
      return rent[0];
    },
    findRentSelf(timePeriod, date, indexTime, indexDate) {
      let rent = this.rents.filter(rent => {
        let rentDate = rent.rentDate.split(' ')[0];

        if (rentDate === date) {
          let drawStatus = 0;
          drawStatus = rent.venueId === this.venueId &&
            rent.statusRent === 2 &&
            rent.statusDraw === 0 &&
            this.checkTimePeriod(rent.rentTimePeriod, timePeriod) &&
            rent.yearUserId == this.yearUserId;
          return drawStatus;
        }

        return false;
      });

      let tempRent = this.tempRents.filter(rent => {
        return rent.timePeriod === timePeriod &&
          rent.date === date &&
          rent.venueId === this.venueId;
      });
      if (rent[0] || tempRent[0]) {
        if (!this.tableObj[indexTime])
          this.tableObj[indexTime] = {};
        this.tableObj[indexTime][indexDate] = rent[0] || tempRent[0];
      }
      return rent[0] || tempRent[0];
    },
    duringMonth(date) {
      let now = new Date().getTime();
      //取當日
      var enddate = new Date();
      //將月份移至下個月份
      enddate.setMonth(enddate.getMonth() + 1);
      //設定為下個月份的第一天
      enddate.setDate(1);
      //將日期-1為當月的最後一天
      enddate.setDate(enddate.getDate() - 1);
      var dateTime = new Date(date).getTime();
      if (this.yearUserId == undefined) {
        return this.venueId && now <= dateTime && dateTime <= enddate.getTime();
      } else {
        return this.venueId && now <= dateTime && dateTime <= enddate.getTime() && this.rentLimit(this.venueId);
      }
    },
    notLogIn(date) {
      if (this.yearUserId == undefined) {
        let now = new Date(),
          thisdate = new Date(date);
        return this.venueId && //當場館被選擇
          now.getMonth() + 1 <= thisdate.getMonth() || //當日期為下個月後
          this.venueId && //或當場館被選擇
          thisdate.getMonth() == 0 && now.getMonth() + 1 == 12; //下個月日期為1月 
      } else {
        return false
      }
    },
    nextMonthAfterLottery(date) {

      //取當日
      var startdate = new Date();
      //將月份移至下個月份
      startdate.setMonth(startdate.getMonth() + 1);
      //設定日期為第一天，
      // 11/23 因計算關係 須為前一月最後一天
      startdate.setDate(0);

      //取當日
      var enddate = new Date();
      //將月份移至下下個月份
      enddate.setMonth(enddate.getMonth() + 2);
      //設定為下下個月份的第一天
      enddate.setDate(1);
      //將日期-1為下個月月的最後一天
      enddate.setDate(enddate.getDate() - 1);

      var dateTime = new Date(date);
      // dateTime.setDate(dateTime.getDate() + 1);

      let now = new Date();

      var postResultTime = new Date(now.getFullYear(), now.getMonth(), this.schedule.postResultD, this.schedule.postResultH, 30, 0).getTime()
      if (this.yearUserId == undefined) {
        return this.venueId && startdate.getTime() <= dateTime.getTime() && dateTime.getTime() <= enddate.getTime() && postResultTime <= now.getTime();
      } else {
        return this.venueId && startdate.getTime() <= dateTime.getTime() && dateTime.getTime() <= enddate.getTime() && postResultTime <= now.getTime() && this.rentLimit(this.venueId);
      }
    },


    duringLottery(date) {
      let now = new Date(),
        thisdate = new Date(date);

      return this.venueId && //當場館被選擇
        now.getMonth() + 1 <= thisdate.getMonth() || //當日期為下個月後
        this.venueId && //或當場館被選擇
        thisdate.getMonth() == 0 && now.getMonth() + 1 == 12; //下個月日期為1月 
    },
    rentLimit(id) {
      if (this.yearuser.rentLimit)
        return this.yearuser.rentLimit.includes(id);
      return false;
    },
    preweek() {
      this.spinShow = true
      if (!this.venueId) return;
      let date = this.searchDate ? this.searchDate : new Date();
      this.searchDate = new Date(new Date(date).getTime() - 7 * 24 * 60 * 60 * 1000);
      this.search();
    },
    nextweek() {
      this.spinShow = true
      if (!this.venueId) return;
      let date = this.searchDate ? this.searchDate : new Date();
      this.searchDate = new Date(new Date(date).getTime() + 7 * 24 * 60 * 60 * 1000);
      this.search();
    },

    searchDateChange(date) {
      this.searchDate = date;
    },
    searchDateClear() {
      this.searchDate = '';
    },
    search() {
      this.initTableDate();
      this.getActivity();
      this.getRent();
    },
    showDate(date) {
      let dateArr = date.split('-');
      dateArr.shift();
      return dateArr.toString().replace(',', '/');
    },
    showDay(index) {
      let days = ['(一)', '(二)', '(三)', '(四)', '(五)', '(六)', '(日)'];
      return days[index];
    },
    showName(indexTime, indexDate) {
      let { activity, rent } = this.tableObj[indexTime][indexDate];
      if (activity)
        return activity.activityName;
      else if (rent) {
        return rent.isYearUser ? rent.yearUserUnitName : rent.unitName;
      }
    },

    showReserveModal(rent) {
      this.modal_reserve = true;
      this.reserveRecord = rent;
    },
    showRentModal(obj) {
      if (obj.activity) {
        this.modal_rent = true;
        this.rentRecord = obj.activity;
      } else if (obj.rent) {
        this.modal_reserve = true;
        this.reserveRecord = obj.rent;
      }
    },
    showRequestModal(timePeriod, date) {
      if (this.yearUserId == undefined) {
        this.modal_wantreser_notlog = true;
      } else {
        this.modal_wantreser = true;
        let venue = this.venues.filter(venue => {
          return venue.id === this.venueId;
        });

        this.requestReserve = {
          buildingName: venue[0].buildingName,
          venueName: venue[0].venueName,
          date,
          timePeriod
        }
      }
    },
    sentcheckout() {
      this.sentcheck = true
      this.shopcar = false
      this.tempRents.every(rent => {
        try {
          this.checkSentField(rent);
        } catch (error) {
          alert(error.message);
          return;
        }
        let form = new FormData();

        form.append('yearUserId', this.yearUserId);
        form.append('isYearUser', 1);
        form.append('rentDate', rent.date);
        form.append('rentTimePeriod', rent.timePeriod);
        form.append('statusRent', 2);
        form.append('venueId', rent.venueId);

        this.$Message.loading({ content: '儲存中...', duration: 0 });

        axios.post(API.rent_yearuserrent, form, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            this.$Message.destroy();
            ShowMessage(Message.SaveSuccessfully[sessionStorage.locale]);
            let rent = response.data;
            let venue = this.venues.filter(venue => {
              return venue.id === rent.venueId;
            });
            rent.buildingName = venue[0].buildingName;
            rent.venueName = venue[0].venueName;
            this.tempRentsRes.push(rent);
            this.recordExistRents = {};
            this.getRent();
            this.getUserRegisterRentCount();
          })
          .catch(error => {
            this.$Message.destroy();
            PostErrorHandler.bind(this)(error, 'rent_yearuserrent');
          });

        return true;
      });
      this.tempRents = [];
    },
    checkSentField(rent) {
      if (!this.yearUserId)
        throw new Error('請輸入使用者id');
      if (!rent.date)
        throw new Error('請輸入預約日期');
      if (!rent.timePeriod)
        throw new Error('請選擇預約時段');
      if (!rent.venueId)
        throw new Error('請選擇預約地點');
    },

    addTempRents(timePeriod, date, venueId) {
      var choosemonth = date.split('-')[1] - 1
      if (choosemonth < 1) {
        choosemonth = 12
      }
      let now = new Date();
      let sTime = new Date(now.getFullYear(), now.getMonth(), this.schedule.registerStartD, this.schedule.registerStartH, this.schedule.registerStartM, 0),
        eTime = new Date(now.getFullYear(), now.getMonth(), this.schedule.registerEndD, this.schedule.registerEndH, this.schedule.registerEndM, 0),
        thisdate = new Date(date),
        postResultTime = new Date(now.getFullYear(), now.getMonth(), this.schedule.postResultD, this.schedule.postResultH, this.schedule.postResultM, 0)
      if (sTime.getTime() <= now.getTime() && now.getTime() <= eTime.getTime()) {
        let count = this.userRegisterRentCount + this.tempRents.length;
        if (count >= this.countLimit) {
          alert('登記已達上限無法再增加');
          return;
        }
        let venue = this.venues.filter(venue => {
          return venue.id === venueId;
        });
        let Rent = {
          buildingName: venue[0].buildingName,
          venueName: venue[0].venueName,
          timePeriod,
          date,
          venueId
        }
        this.tempRents.push(Rent);
      } else {
        alert(`抽籤登記時間為 ${choosemonth} / ${sTime.getDate()} ${sTime.getHours()} : ${sTime.getMinutes()} ~ ${choosemonth}/${eTime.getDate()} ${eTime.getHours()} : ${eTime.getMinutes()}
公告抽籤時間為 ${choosemonth} / ${postResultTime.getDate()} ${postResultTime.getHours()} : ${postResultTime.getMinutes()}`)
      }

    },
    cancelTempRents(timePeriod, date, venueId) {
      let index = 0;
      let find = this.tempRents.some(rent => {
        if (rent.timePeriod === timePeriod && rent.date === date && rent.venueId === venueId) {
          return true;
        }
        index++;
        return false;
      });
      if (!find)
        alert('無法取消已送出登記');
      else
        this.tempRents.splice(index, 1);
    },
    cancelTempRentsIndex(index) {
      this.tempRents.splice(index, 1);
    },
    saveData(timePeriod, rentDate) {
      try {
        this.checkField();
      } catch (error) {
        alert(error.message);
        return;
      }
      let form = new FormData();

      form.append('yearUserId', this.yearUserId);
      form.append('isYearUser', 1);
      form.append('rentDate', this.requestReserve.date);
      form.append('rentTimePeriod', this.requestReserve.timePeriod);
      form.append('statusRent', 1);
      form.append('venueId', this.venueId);

      this.$Message.loading({ content: '儲存中...', duration: 0 });

      axios.post(API.rent_yearuserrent, form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          this.$Message.destroy();
          ShowMessage(Message.SaveSuccessfully[sessionStorage.locale]);
          this.recordExistRents = {};
          this.getRent('modal');
        })
        .catch(error => {
          this.$Message.destroy();
          PostErrorHandler.bind(this)(error, 'rent_yearuserrent');
        });
    },
    checkField() {
      if (!this.yearUserId)
        throw new Error('請輸入使用者id');
      if (!this.requestReserve.date)
        throw new Error('請輸入預約日期');
      if (!this.requestReserve.timePeriod)
        throw new Error('請選擇預約時段');
      if (!this.venueId)
        throw new Error('請選擇預約地點');
    },
    toLogIn() {
      this.$router.push({ name: 'account_app' });
    }
  },
}

</script>
<style lang="scss">
@import "/../static/rent/css/jcDate.css";

.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    height: 400px;
    top: 0;

    table {
      border-collapse: collapse;
      word-wrap: break-word;
      word-break: break-all;

      th,
      td {
        border: 1px solid #ddd;
        padding: 10px;
        font-size: 14px;

        &:first-child {
          text-align: right;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// SiteInq.vue?03c9d3a3